export enum ProfileType {
  vendor = 'vendor',
  developer = 'developer',
  investor = 'investor'
}
